import PND3ReportComponent from "features/Report/components/SalaryGroup/PND3Report";
import usePND3Report from "features/Report/hooks/salaryGroup/usePND3Report";

const PND3ReportPage = () => {
    const usePND3ReportProps = usePND3Report();
    return (<PND3ReportComponent {...usePND3ReportProps} />)
}

export default PND3ReportPage;